module.exports = __webpack_public_path__ + "static/media/void_radio.ce46c0b5.svg";